import React from 'react'

import type {Props as ModalProps} from '@/components/modal'
import type {Args} from '@/hooks/use-signup'
import type {FormConfig} from '@/types/consents'

import {RebrandSignupModal} from './rebrand-signup-modal'

export interface Props extends Omit<ModalProps, 'children'> {
    signupProps?: Args
    formConfig?: FormConfig
    highlightedFeatures?: string[]
    onSignup?: (value: boolean) => void
}

export const SignupModal = ({
    isOpen,
    onDismiss,
    onSignup,
    signupProps = {form: 'Front'},
}: Partial<Props>) => {
    const handleDismiss = () => {
        onDismiss?.()
    }

    return (
        <RebrandSignupModal
            isOpen={isOpen}
            onDismiss={handleDismiss}
            signupProps={signupProps}
            onSignup={onSignup}
        />
    )
}
